import TemplateMixin from './TemplateMixin';
import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';

@Component({})
export default class EventListTemplate extends Mixins(TemplateMixin) {
  @Prop({ default: null })
  themeId: number;

  $refs: {
    widgetIframe: HTMLIFrameElement;
  };

  @Watch('eventListUrl')
  themeIdWatcher() {
    if (this.$refs.widgetIframe) this.$refs.widgetIframe.contentWindow.location.reload();
  }

  get eventListUrl(): string {
    const token = this.userSLWidgetToken || this.widgetToken;
    if (!token) return '';

    const eventListBaseUrl = `${process.env.MIX_STREAMLABS_URL}/widgets/studio/event-list/v1/${token}`;

    return `${eventListBaseUrl}${!this.component.useSLSettings && this.themeId ? `/${this.themeId}` : ''}${this.isEditor ? '?simulate=true' : ''}`;
  }
}
